export default __webpack_public_path__ + "scripts/resources/assignments/en/chemvlab/IV/IV_make_saline/spectra.json";